// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-row {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  margin-top: 0.75rem;
  padding: 0.625rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  box-sizing: border-box;
  gap: 0.375rem;
}

.download-ready-notice {
  position: fixed;
  z-index: 10020;
  width: 15.5rem;
  padding: 0.8rem 0.9rem 0.7rem;
  border: 1px solid #bfdbfe;
  border-radius: 0.625rem;
  background: #ffffff;
  color: #1f2937;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.18);
  box-sizing: border-box;
}

.download-ready-notice--left {
  transform: translate(-100%, -50%);
}

.download-ready-notice--above {
  transform: translateY(-100%);
}

.download-ready-notice--left::after {
  content: '';
  position: absolute;
  left: calc(100% + 1px);
  top: 50%;
  width: 0;
  height: 0;
  transform: translateY(-50%);
  border: 0.45rem solid transparent;
  border-left-color: #bfdbfe;
}

.download-ready-notice--above::after {
  content: '';
  position: absolute;
  left: 1.5rem;
  top: 100%;
  width: 0;
  height: 0;
  border: 0.45rem solid transparent;
  border-top-color: #bfdbfe;
}

.download-ready-notice--light .download-ready-notice__settings-hint {
  color: #4b5563;
}

.download-ready-notice__message {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin: 0 1rem 0.7rem 0;
}

.download-ready-notice__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  border: 1px solid rgba(209, 213, 219, 0.95);
  border-radius: 999px;
  background: #ffffff;
}

.download-ready-notice__avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}

.download-ready-notice__message p {
  flex: 1 1;
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.4;
}

.download-ready-notice__close {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: color 0.15s;
}

.download-ready-notice__close:hover {
  color: #374151;
}

.download-ready-notice__close svg {
  width: 1.1rem;
  height: 1.1rem;
}

.download-ready-notice--dark .download-ready-notice__close {
  color: #6b7280;
}

.download-ready-notice--dark .download-ready-notice__close:hover {
  color: #e5e7eb;
}

.download-ready-notice__settings-hint {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 0.55rem;
  border-top: 1px solid rgba(59, 130, 246, 0.16);
  color: #4b5563;
  font-size: 0.66rem;
  line-height: 1.35;
}

.download-ready-notice__settings-hint strong {
  margin-left: 0.25rem;
  color: #1d4ed8;
  font-weight: 700;
}

.download-ready-notice--dark {
  border-color: #3b82f6;
  background: #172554;
  color: #dbeafe;
}

.download-ready-notice--dark .download-ready-notice__settings-hint {
  border-top-color: rgba(96, 165, 250, 0.18);
  color: #bfdbfe;
}

.download-ready-notice--dark .download-ready-notice__settings-hint strong {
  color: #93c5fd;
}

.download-ready-notice--dark.download-ready-notice--left::after {
  border-left-color: #3b82f6;
}

.download-ready-notice--dark.download-ready-notice--above::after {
  border-top-color: #3b82f6;
}

.download-row--selection-cue {
  border-color: #3b82f6;
  background: #dbeafe;
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.42),
    0 0 30px rgba(59, 130, 246, 0.82);
}

.dark .download-row {
  border-color: #374151;
}

.dark .download-row--selection-cue {
  border-color: #60a5fa;
  background: #1e3a5f;
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.3),
    0 0 28px rgba(96, 165, 250, 0.44);
}

.download-row-inner {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 0.625rem;
}

.download-action-item {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
}

.download-row-status {
  font-size: 0.6875rem;
  color: #9ca3af;
  font-style: italic;
}

.dark .download-row-status {
  color: #6b7280;
}

.download-icon-button.disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.download-icon-button.disabled:hover {
  background-color: #e5e7eb;
  border-color: #d1d5db;
}

.dark .download-icon-button.disabled:hover {
  background-color: #1e3a8a;
  border-color: #1e40af;
}

.download-label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #4b5563;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dark .download-label {
  color: #9ca3af;
}

.download-row-status--hint {
  width: 100%;
  text-align: center;
}

.download-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  background-color: #e5e7eb;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.download-icon-button:hover {
  background-color: #d1d5db;
  border-color: #9ca3af;
}

.dark .download-icon-button {
  background-color: #1e3a8a;
  color: #ffffff;
  border: 1px solid #1e40af;
}

.dark .download-icon-button:hover {
  background-color: #1e40af;
  border-color: #2563eb;
}

@media (max-width: 520px) {
  .download-row {
    padding-inline: 0.75rem;
  }

  .download-row-inner {
    grid-template-columns: 1fr;
  }

}

.post-session-metrics-layout {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  width: 100%;
}

.post-session-metrics-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 2rem 1.25rem 1.25rem;
}

.post-session-metrics-body::-webkit-scrollbar {
  display: none;
}

.post-session-action-dock {
  margin-top: auto;
}

.restart-session-container {
  margin-top: 1rem;
}

.restart-session-tooltip-wrap {
  position: relative;
  width: 100%;
}

.restart-session-tooltip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 0.55rem);
  transform: translateX(-50%);
  width: min(17rem, calc(100vw - 3rem));
  padding: 0.6rem 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: rgba(255, 255, 255, 0.98);
  color: #475569;
  font-size: 0.75rem;
  line-height: 1.45;
  text-align: center;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
  z-index: 3;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.18s ease, visibility 0.18s ease;
}

.restart-session-tooltip-wrap:hover .restart-session-tooltip {
  opacity: 1;
  visibility: visible;
}

.restart-session-button {
  width: 100%;
  padding: 0.75rem 1rem;
  background-color: #e5e7eb;
  color: #111827;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.restart-session-button--selection-cue {
  border-color: #3b82f6;
  background: #dbeafe;
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.42),
    0 0 30px rgba(59, 130, 246, 0.82);
}

.restart-session-button:hover {
  background-color: #d1d5db;
  border-color: #9ca3af;
}

.dark .restart-session-button {
  background-color: #1e3a8a;
  color: #ffffff;
  border: 1px solid #1e40af;
}

.dark .restart-session-button--selection-cue {
  border-color: #60a5fa;
  background: #1e3a5f;
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.3),
    0 0 28px rgba(96, 165, 250, 0.44);
}

.dark .restart-session-button:hover {
  background-color: #1e40af;
  border-color: #2563eb;
}

.dark .restart-session-tooltip {
  border-color: rgba(71, 85, 105, 0.7);
  background: rgba(15, 23, 42, 0.96);
  color: rgba(226, 232, 240, 0.88);
  box-shadow: 0 14px 30px rgba(2, 6, 23, 0.35);
}

.end-reason-section {
  margin: 1rem 0 0.85rem;
  padding: 0.72rem 0.82rem;
  border: 1px solid #d1d5db;
  border-radius: 0.65rem;
  background: rgba(255, 255, 255, 0.42);
  text-align: center;
}

.dark .end-reason-section {
  background: rgba(15, 23, 42, 0.22);
  border-color: rgba(75, 85, 99, 0.75);
}

.end-reason-label {
  display: block;
  color: #6b7280;
  font-size: 0.73rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
}

.dark .end-reason-label {
  color: #9ca3af;
}

.end-reason-text {
  margin: 0.38rem 0 0;
  color: #1f2937;
  font-size: 0.88rem;
  line-height: 1.45;
  text-align: center;
}

.dark .end-reason-text {
  color: #e5e7eb;
}

.review-analytics-container {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

.dark .review-analytics-container {
  border-top-color: #374151;
}

.review-analytics-button {
  width: 100%;
  padding: 0.625rem 1rem;
  background-color: transparent;
  color: #3b82f6;
  border: 1px solid #3b82f6;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.review-analytics-button:hover {
  background-color: rgba(59, 130, 246, 0.1);
  border-color: #2563eb;
  color: #2563eb;
}

.dark .review-analytics-button {
  color: #60a5fa;
  border-color: #60a5fa;
}

.dark .review-analytics-button:hover {
  background-color: rgba(96, 165, 250, 0.15);
  border-color: #93c5fd;
  color: #93c5fd;
}

@media (max-width: 768px) {
  .restart-session-button {
    font-size: 0.85rem;
    padding: 0.5rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/report/ReportFullSessionPostSessionPanel.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,8CAA8C;EAC9C,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;AAEF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,8CAA8C;EAC9C,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF","sourcesContent":[".download-row {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 100%;\n  margin-top: 0.75rem;\n  padding: 0.625rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  box-sizing: border-box;\n  gap: 0.375rem;\n}\n\n.download-ready-notice {\n  position: fixed;\n  z-index: 10020;\n  width: 15.5rem;\n  padding: 0.8rem 0.9rem 0.7rem;\n  border: 1px solid #bfdbfe;\n  border-radius: 0.625rem;\n  background: #ffffff;\n  color: #1f2937;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.18);\n  box-sizing: border-box;\n}\n\n.download-ready-notice--left {\n  transform: translate(-100%, -50%);\n}\n\n.download-ready-notice--above {\n  transform: translateY(-100%);\n}\n\n.download-ready-notice--left::after {\n  content: '';\n  position: absolute;\n  left: calc(100% + 1px);\n  top: 50%;\n  width: 0;\n  height: 0;\n  transform: translateY(-50%);\n  border: 0.45rem solid transparent;\n  border-left-color: #bfdbfe;\n}\n\n.download-ready-notice--above::after {\n  content: '';\n  position: absolute;\n  left: 1.5rem;\n  top: 100%;\n  width: 0;\n  height: 0;\n  border: 0.45rem solid transparent;\n  border-top-color: #bfdbfe;\n}\n\n.download-ready-notice--light .download-ready-notice__settings-hint {\n  color: #4b5563;\n}\n\n.download-ready-notice__message {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  margin: 0 1rem 0.7rem 0;\n}\n\n.download-ready-notice__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 2rem;\n  width: 2rem;\n  height: 2rem;\n  overflow: hidden;\n  border: 1px solid rgba(209, 213, 219, 0.95);\n  border-radius: 999px;\n  background: #ffffff;\n}\n\n.download-ready-notice__avatar svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.download-ready-notice__message p {\n  flex: 1;\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.download-ready-notice__close {\n  position: absolute;\n  top: 0.3rem;\n  right: 0.3rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: color 0.15s;\n}\n\n.download-ready-notice__close:hover {\n  color: #374151;\n}\n\n.download-ready-notice__close svg {\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n.download-ready-notice--dark .download-ready-notice__close {\n  color: #6b7280;\n}\n\n.download-ready-notice--dark .download-ready-notice__close:hover {\n  color: #e5e7eb;\n}\n\n.download-ready-notice__settings-hint {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 0.55rem;\n  border-top: 1px solid rgba(59, 130, 246, 0.16);\n  color: #4b5563;\n  font-size: 0.66rem;\n  line-height: 1.35;\n}\n\n.download-ready-notice__settings-hint strong {\n  margin-left: 0.25rem;\n  color: #1d4ed8;\n  font-weight: 700;\n}\n\n.download-ready-notice--dark {\n  border-color: #3b82f6;\n  background: #172554;\n  color: #dbeafe;\n}\n\n.download-ready-notice--dark .download-ready-notice__settings-hint {\n  border-top-color: rgba(96, 165, 250, 0.18);\n  color: #bfdbfe;\n}\n\n.download-ready-notice--dark .download-ready-notice__settings-hint strong {\n  color: #93c5fd;\n}\n\n.download-ready-notice--dark.download-ready-notice--left::after {\n  border-left-color: #3b82f6;\n}\n\n.download-ready-notice--dark.download-ready-notice--above::after {\n  border-top-color: #3b82f6;\n}\n\n.download-row--selection-cue {\n  border-color: #3b82f6;\n  background: #dbeafe;\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.42),\n    0 0 30px rgba(59, 130, 246, 0.82);\n}\n\n.dark .download-row {\n  border-color: #374151;\n}\n\n.dark .download-row--selection-cue {\n  border-color: #60a5fa;\n  background: #1e3a5f;\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.3),\n    0 0 28px rgba(96, 165, 250, 0.44);\n}\n\n.download-row-inner {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  gap: 0.625rem;\n}\n\n.download-action-item {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n}\n\n.download-row-status {\n  font-size: 0.6875rem;\n  color: #9ca3af;\n  font-style: italic;\n}\n\n.dark .download-row-status {\n  color: #6b7280;\n}\n\n.download-icon-button.disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.download-icon-button.disabled:hover {\n  background-color: #e5e7eb;\n  border-color: #d1d5db;\n}\n\n.dark .download-icon-button.disabled:hover {\n  background-color: #1e3a8a;\n  border-color: #1e40af;\n}\n\n.download-label {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #4b5563;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dark .download-label {\n  color: #9ca3af;\n}\n\n.download-row-status--hint {\n  width: 100%;\n  text-align: center;\n}\n\n.download-icon-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  background-color: #e5e7eb;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.download-icon-button:hover {\n  background-color: #d1d5db;\n  border-color: #9ca3af;\n}\n\n.dark .download-icon-button {\n  background-color: #1e3a8a;\n  color: #ffffff;\n  border: 1px solid #1e40af;\n}\n\n.dark .download-icon-button:hover {\n  background-color: #1e40af;\n  border-color: #2563eb;\n}\n\n@media (max-width: 520px) {\n  .download-row {\n    padding-inline: 0.75rem;\n  }\n\n  .download-row-inner {\n    grid-template-columns: 1fr;\n  }\n\n}\n\n.post-session-metrics-layout {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n}\n\n.post-session-metrics-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding: 2rem 1.25rem 1.25rem;\n}\n\n.post-session-metrics-body::-webkit-scrollbar {\n  display: none;\n}\n\n.post-session-action-dock {\n  margin-top: auto;\n}\n\n.restart-session-container {\n  margin-top: 1rem;\n}\n\n.restart-session-tooltip-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.restart-session-tooltip {\n  position: absolute;\n  left: 50%;\n  bottom: calc(100% + 0.55rem);\n  transform: translateX(-50%);\n  width: min(17rem, calc(100vw - 3rem));\n  padding: 0.6rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  background: rgba(255, 255, 255, 0.98);\n  color: #475569;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  text-align: center;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);\n  z-index: 3;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.18s ease, visibility 0.18s ease;\n}\n\n.restart-session-tooltip-wrap:hover .restart-session-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n.restart-session-button {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background-color: #e5e7eb;\n  color: #111827;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.restart-session-button--selection-cue {\n  border-color: #3b82f6;\n  background: #dbeafe;\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.42),\n    0 0 30px rgba(59, 130, 246, 0.82);\n}\n\n.restart-session-button:hover {\n  background-color: #d1d5db;\n  border-color: #9ca3af;\n}\n\n.dark .restart-session-button {\n  background-color: #1e3a8a;\n  color: #ffffff;\n  border: 1px solid #1e40af;\n}\n\n.dark .restart-session-button--selection-cue {\n  border-color: #60a5fa;\n  background: #1e3a5f;\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.3),\n    0 0 28px rgba(96, 165, 250, 0.44);\n}\n\n.dark .restart-session-button:hover {\n  background-color: #1e40af;\n  border-color: #2563eb;\n}\n\n.dark .restart-session-tooltip {\n  border-color: rgba(71, 85, 105, 0.7);\n  background: rgba(15, 23, 42, 0.96);\n  color: rgba(226, 232, 240, 0.88);\n  box-shadow: 0 14px 30px rgba(2, 6, 23, 0.35);\n}\n\n.end-reason-section {\n  margin: 1rem 0 0.85rem;\n  padding: 0.72rem 0.82rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.65rem;\n  background: rgba(255, 255, 255, 0.42);\n  text-align: center;\n}\n\n.dark .end-reason-section {\n  background: rgba(15, 23, 42, 0.22);\n  border-color: rgba(75, 85, 99, 0.75);\n}\n\n.end-reason-label {\n  display: block;\n  color: #6b7280;\n  font-size: 0.73rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.dark .end-reason-label {\n  color: #9ca3af;\n}\n\n.end-reason-text {\n  margin: 0.38rem 0 0;\n  color: #1f2937;\n  font-size: 0.88rem;\n  line-height: 1.45;\n  text-align: center;\n}\n\n.dark .end-reason-text {\n  color: #e5e7eb;\n}\n\n.review-analytics-container {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.dark .review-analytics-container {\n  border-top-color: #374151;\n}\n\n.review-analytics-button {\n  width: 100%;\n  padding: 0.625rem 1rem;\n  background-color: transparent;\n  color: #3b82f6;\n  border: 1px solid #3b82f6;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.review-analytics-button:hover {\n  background-color: rgba(59, 130, 246, 0.1);\n  border-color: #2563eb;\n  color: #2563eb;\n}\n\n.dark .review-analytics-button {\n  color: #60a5fa;\n  border-color: #60a5fa;\n}\n\n.dark .review-analytics-button:hover {\n  background-color: rgba(96, 165, 250, 0.15);\n  border-color: #93c5fd;\n  color: #93c5fd;\n}\n\n@media (max-width: 768px) {\n  .restart-session-button {\n    font-size: 0.85rem;\n    padding: 0.5rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
